import React from "react";
import "./Footer.css"
import { withRouter,NavLink } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';


// import Logo from "/images/logo.png"

export const Footer=()=>{
    return(
        
      <footer className="footer-section">
      <div className="container">
        
        {/* <div className="footer-cta pt-5 pb-5">
          <div className="row">
            <div className="col-xl-4 col-md-4 mb-30 d-flex ai-center  ">
              <div className="single-cta d-flex ai-center">
                <i className="fa fa-map-marker" />
                <div className="cta-text">
                  <h4>Find us</h4>
                  <span>1010 Avenue, sw 54321, chandigarh</span>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 mb-30 d-flex ai-center ">
              <div className="single-cta">
                <i className="fa fa-phone" />
                <div className="cta-text">
                  <h4>Call us</h4>
                  <span><a href="tel:92123456">981234567</a></span>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 mb-30 d-flex ai-center ">
              <div className="single-cta">
                <i className="fa fa-envelope-open" />
                <div className="cta-text">
                  <h4>Mail us</h4>
                  <span><a href="mailto:someone@example.com">example@gmail.com</a></span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        
        <div className="footer-content pt-5 pb-5">
          <div className="row" style={{alignItems:'baseline'}}>
            <div className="col-xl-6 col-lg-6 mb-50">
              <div className="footer-widget">
                <div className="footer-logo">
                  <a href="#"><img src="/Images/LogoFinal.png" className="img-fluid" alt="logo" /></a>
                </div>
                <div className="footer-text">
                  <p>rate.review.repeat is Fiji's first community powered review site. We seek to create a safe community of conscientious reviewers with the sole purpose of helping consumers in their decision-making, as well as to assist organisations in becoming better and doing better. The best reviews are passionate and personal because they offer a rich narrative, a wealth of detail, and provide guidance to other consumers. r3 does not take sides, so we expect you to stand behind your review – make it count!</p>
                </div>
                
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-30 center-larger my20-sm">
              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>Useful Links</h3>
                </div>
                <ul>
                  <li><a href="#">Home</a></li>
                  <li><a href="/user-guide">User guide</a></li>
                  <li><a href="#">About us</a></li>
                  <li>
                  <Nav.Link href="/contactus" className="p-0">Contact us</Nav.Link>
                    {/* <a href="#">Contact us</a> */}
                    </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-2 col-lg-2 col-md-6 mb-50">
                <div className="footer-social-icon mb-2">
                <div className="footer-widget-heading">
                  <h3>Follow us</h3>
                </div>
                  <a href="#"><i className="fa fa-facebook-f facebook-bg" /></a>
                  <a href="#"><i className="fa fa-twitter twitter-bg" /></a>
                </div>
              {/* <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>Subscribe</h3>
                </div>
                <div className="footer-text mb-25">
                  <p>Don’t miss to subscribe to our new feeds, kindly fill the form below.</p>
                </div>
                <div className="subscribe-form">
                  <form action="#">
                    <input type="text" placeholder="Email Address" />
                    <button><i className="fa fa-telegram" /></button>
                  </form>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 text-center text-lg-left">
              <div className="copyright-text">
                <p>Copyright © 2018, All Right Reserved <a href="#">RRR</a></p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 d-none d-lg-block text-right">
              <div className="footer-menu">
                <ul>
                  {/* <li><NavLink to="#">Home</NavLink></li> */}
                  <li><Nav.Link href="/legal" className="p-0">Legal</Nav.Link></li>
                  {/* <li><Nav.Link href="/user-guide" className="p-0">User Guide</Nav.Link></li> */}
                  {/* <li><NavLink to="#">Privacy</NavLink></li> */}
                  {/* <li><NavLink to="#">Policy</NavLink></li> */}
                  {/* <li><NavLink to="#">Contact</NavLink></li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    )
}